export const NFT_TRANSFORM_E2E_BUILD_MARKER =
  "nft-transform-e2e-2026-08-31-v2-us-allocation-fmv";
